var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var Eye = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 0C13.0523 0 13.5 0.447715 13.5 1V3.03508C14.6716 3.11756 15.8017 3.34379 16.8665 3.69532L18.134 1.5C18.4101 1.02171 19.0217 0.857833 19.5 1.13398C19.9783 1.41012 20.1422 2.02171 19.866 2.5L18.7286 4.47014C21.3715 5.81472 23.4307 7.99487 24.4351 10.6457C24.5216 10.874 24.5216 11.126 24.4351 11.3543C22.7294 15.8557 17.9822 19 12.5 19C7.01781 19 2.27057 15.8557 0.564883 11.3543C0.478373 11.126 0.478372 10.874 0.564882 10.6457C1.61822 7.86584 3.83151 5.60357 6.66152 4.27976L5.63397 2.5C5.35783 2.02171 5.52171 1.41012 6 1.13397C6.47829 0.857832 7.08988 1.02171 7.36602 1.5L8.55716 3.56311C9.49642 3.28674 10.4826 3.10671 11.5 3.03508V1C11.5 0.447715 11.9477 0 12.5 0ZM2.57871 11C4.07168 14.4567 7.90593 17 12.5 17C17.0941 17 20.9283 14.4567 22.4213 11C20.9283 7.54333 17.0941 5 12.5 5C7.90593 5 4.07168 7.54334 2.57871 11ZM15.5 11C15.5 12.6569 14.1569 14 12.5 14C10.8431 14 9.5 12.6569 9.5 11C9.5 9.34315 10.8431 8 12.5 8C14.1569 8 15.5 9.34315 15.5 11Z", fill: "currentColor" }) })));
};
